import {Task} from '@/types/TaskTypes';

export class TaskManager {
    static async loadTasks(): Promise<Task[]> {
        const stored = localStorage.getItem('checkliste.tasks');
        if (stored) {
            return JSON.parse(stored);
        } else {
            const names: string[] = await (await fetch('./tasknames.json')).json();
            const tasks: Task[] =  names.map(name => ({text: name, completed: false}));
            localStorage.setItem('checkliste.tasks', JSON.stringify(tasks));
            return tasks;
        }
    }

    static saveTasks(tasks: Task[]) {
        localStorage.setItem('checkliste.tasks', JSON.stringify(tasks));
    }

    static clearTasks() {
        localStorage.removeItem('checkliste.tasks');
    }
}
